export default __webpack_public_path__ + "static/media/tete23.24d40579.png";